import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  instituteLength: 0,
  institute: [],
  instituteError: "",
  formError: "",
}

export default function instituteReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_INSTITUTE:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_INSTITUTE:
      return {...state, saveLoader: action.payload}
    case actions.GET_INSTITUTE:
      return {...state, institute: action.payload.institute, instituteLength: action.payload.instituteLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.INSTITUTE_FAIL:
      return { ...state, instituteError: action.payload };
    default:
      return {...state};
  }
}